<template>
  <div id="app">
    <!--控制页面是否被缓存-->
    <keep-alive >
      <router-view v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"/>
  </div>
</template>
<script>
    export default {
        name: 'App',
        provide () {    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。                                             
            return {
                reload: this.reload                                            
            }
        },
        data() {
            return{
              isRouterAlive: true, //控制视图是否显示的变量
            }
        },
        methods: {
            reload () {
                this.$route.meta.keepAlive = false;
            }
        }
    }
</script>
<style lang="scss">
#app {
  font-size: 36px;
  color: #222A2A;
}
img{
  width:100%;
}
.van-uploader__upload-icon{
  color: #999 !important;
}

</style>
